import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import { Grid, Typography, Divider } from "@mui/material";

import CustomDataGrid from "./CustomDataGrid";
import useReports from "../../../hooks/useReports";
import { useDialog } from "../../../contexts/DialogContext";
import Stats from "../../../components/Stats";
import { formatDate, roundOff } from "../../../utils/common";
import { AccountBalanceWallet as WalletIcon } from "@mui/icons-material";

function WalletReports() {
  const {
    getAllWallet,
    walletReports,
    isLoading,
    downloadWalletReport,
    getWalletSumAmounts,
    walletSumAmount,
  } = useReports();

  const { totalNumberOfRecords, hasNextPage, pageNumber, pageSize } = walletReports.paging;

  console.log(totalNumberOfRecords, "totalNumberOfRecords");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDialog } = useDialog();

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const today = formatDate(new Date());

  const currentPayload = {
    filters: [
      {
        fieldName: "createdAt",
        fieldValue: `${today} 00:00:00,${today} 23:59:59`,
        op: "btn",
        dataType: "string",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "desc",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);

  const [filterFormData, setFilterFormData] = useState({
    createdAt: [new Date(), new Date()],
    createdAtStr: `${today} 00:00:00,${today} 23:59:59`,
  });

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllWallet(payload);
  };

  const fetchWalletSumAmounts = async () => {
    const { pagination, ...payloadWithoutPagination } = payload;
    await getWalletSumAmounts(payloadWithoutPagination);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    setFilterFormData({
      createdAt: [new Date(), new Date()],
      createdAtStr: `${today} 00:00:00,${today} 23:59:59`,
      walletType: {},
    });
    filterResetFunc();
    setPaginationModel({
      page: 0,
      pageSize: 100,
    });
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  const paginationMetaRef = useRef();

  // Memoize to avoid flickering when the `hasNextPage` is `undefined` during refetch
  const paginationMeta = React.useMemo(() => {
    if (hasNextPage !== undefined && paginationMetaRef.current?.hasNextPage !== hasNextPage) {
      paginationMetaRef.current = { hasNextPage };
    }
    return paginationMetaRef.current;
  }, [hasNextPage]);

  useEffect(() => {
    fetchData();
    fetchWalletSumAmounts();
  }, [payload]);

  const addWallet = () => {
    navigate("/cpanel/wallet/add");
  };
  const editWallet = (id) => {
    console.log(id);
    navigate("/cpanel/wallet/edit", { state: { id: id } });
  };

  const exportFile = async (fileType) => {
    await downloadWalletReport(fileType, payload);
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  return (
    <React.Fragment>
      <Helmet title="SaaS Dashboard" />
      <Grid justifyContent="space-between" container spacing={6}>
        <Grid item>
          <Typography variant="h4" gutterBottom>
            Total Wallet Amount
          </Typography>
        </Grid>
      </Grid>
      <Divider my={4} />
      <Grid container spacing={6} mt={1}>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Amount"
            amount={"₹" + roundOff(walletSumAmount)}
            chip="Monthly"
            bgcolor="#3b82f6"
            icon={WalletIcon}
          />
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CustomDataGrid
            trans={t}
            addPage={null}
            editPage={null}
            refreshPage={refreshPage}
            downloadFile={exportFile}
            openDownloadDialog={null}
            id="walletEntryId"
            data={walletReports.data}
            rowCount={totalNumberOfRecords}
            paging={{
              page: pageNumber,
              pageSize: pageSize,
            }}
            onPaginationModelChange={onPageChange}
            isLoading={isLoading}
            sortModel={sortModel}
            handleSortModelChange={handleSortModelChange}
            setPayload={setPayload}
            payload={payload}
            setFilterResetFunc={setFilterResetFunc}
            paginationMeta={paginationMeta}
            paginationModel={paginationModel}
            filterFormData={filterFormData}
            setFilterFormData={setFilterFormData}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default WalletReports;
